import { useMediaQuery } from "react-responsive"

import PropTypes from "prop-types"

import { Field, useFormikContext } from "formik"

import {
  getValueForCheckbox,
  updateAllDependentValues,
} from "../../../../helpers/configuration/resets/resetDependencies"
import Tooltip from "../../../Tooltip/Tooltip"
import ErrorMessage from "../ErrorMessage/ErrorMessage"

import styles from "./MuestraCuadrada.module.scss"

const MuestraCuadrada = props => {
  const { title, name, options, multiselect, columns } = props

  const formik = useFormikContext()
  const { values, errors, handleChange, setValues } = formik

  const handleChangeField = event => {
    handleChange(event)

    const value = multiselect
      ? getValueForCheckbox(event, values)
      : event.target.value

    setValues(updateAllDependentValues(name, value, formik))
  }

  const handleChangeFieldFake = () => {
    return false
  }

  const fieldValue = values[name]

  const Mobil = ({ children }) => {
    const isSmall = useMediaQuery({ query: "(max-width: 767px)" })
    return isSmall ? children : null
  }
  const getIsChecked = value => {
    if (!value) {
      return false
    }

    if (multiselect) {
      return fieldValue.includes(value)
    }

    return fieldValue === value
  }

  if (!options || options.length <= 0 || options.every(o => o.hidden)) {
    return ""
  }

  const getSelectedOptionName = options => {
    if (!options || options.length <= 0) {
      return null
    }

    const selectedValue = values[name]
    const found = options.find(i => i.value === selectedValue)

    if (!found) {
      return null
    }

    return found.text ?? ""
  }

  const selecterOptionName = getSelectedOptionName(options)

  return (
    <div className={[styles.content, !title ? styles.noTitle : " "].join(" ")}>
      {title && <p className={styles.titleField}>{title}</p>}
      {errors[name] && (
        <div
          className={[styles.errorMessage, title ? styles.withTitle : " "].join(
            " "
          )}
        >
          <ErrorMessage name={name} />
        </div>
      )}
      {selecterOptionName && (
        <Mobil>
          <p className={styles.seleccionado}>{selecterOptionName}</p>
        </Mobil>
      )}
      {options.length > 0 && (
        <ul className={styles.listChecks}>
          {options.map(option => {
            const {
              text: optionText,
              value: optionValue,
              description: optionDescription,
              disabled: optionDisabled = false,
              hidden: optionHidden = false,
              image: optionImage,
              bloqued: optionBloqued,
            } = option

            if (optionHidden) {
              return ""
            }

            const isChecked = getIsChecked(optionValue)
            const isDisabled = !option.active || optionDisabled || optionBloqued

            return (
              <li key={`field-${name}-option-${optionText}-${optionValue}`} className={columns}>
                <span className={[styles.contentLabel].join(" ")}>
                  <span
                    className={[
                      styles.forImage,
                      isDisabled ? styles.disabled : " ",
                      isChecked ? styles.checked : " ",
                      isDisabled ? styles.cursorNotAllowed : "",
                    ].join(" ")}
                  >
                    <label
                      className={[
                        styles.label,
                        isDisabled ? styles.disabled : " ",
                        isChecked ? styles.checked : " ",
                        isDisabled ? styles.cursorNotAllowed : "",
                      ].join(" ")}
                      data-for={`field-${name}-option-${optionValue}`}
                      data-tip={optionDescription}
                    >
                      {optionImage && (
                        <span className={styles.imgContent}>
                          <img src={optionImage} alt={optionDescription} />
                        </span>
                      )}
                      <span className={styles.text}>{optionText}</span>
                      <Tooltip
                        place="top"
                        identificador={`field-${name}-option-${optionValue}`}
                      />

                      {multiselect ? (
                        <Field
                          type="checkbox"
                          name={name}
                          value={optionValue}
                          disabled={isDisabled}
                          className={styles.input}
                          onChange={
                            !optionBloqued
                              ? handleChangeField
                              : handleChangeFieldFake
                          }
                        />
                      ) : (
                        <Field
                          type="radio"
                          name={name}
                          value={optionValue}
                          disabled={isDisabled}
                          className={styles.input}
                          onChange={
                            !optionBloqued
                              ? handleChangeField
                              : handleChangeFieldFake
                          }
                        />
                      )}
                    </label>
                  </span>
                </span>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default MuestraCuadrada

MuestraCuadrada.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
      image: PropTypes.string,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
    })
  ),
  multiselect: PropTypes.bool,
}

MuestraCuadrada.defaultProps = {
  title: "",
  name: "",
  options: [],
  multiselect: false,
}
